
import AssetTable from "components/Tables/Assets";

export const EmployeeAssets = ({userData}) => {

  return (
    <>
   

        {/* /Assests Tab */}
        <div className="tab-pane fade" id="emp_assets" style={{ padding: window.innerWidth < 768 ? "8px 0 160px 0" : "12px 0 80px 0" }}>
            <AssetTable userData={userData}/>
        </div>
        {/* /Bank Tab */}

      
    </>
  );
};
